import React, { useEffect, useState } from 'react'
import { redirect, useNavigate, useParams } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import { Button, Fab, Grid } from '@mui/material';

export const SubHeader = () => {
    const Navigate = useNavigate();


    const goBack = () => {
        window.history.back();
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            xs={12}
        >
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                xs={11.5}
            >
                <Fab className='returnButton' variant="contained" size='medium' color="primary" onClick={() => goBack()}>
                    <ArrowBackIcon fontSize="medium" />
                </Fab>
                
                <Fab className='returnButton' variant="contained" size='medium' color="primary" onClick={() => Navigate("/")}>
                    <HomeIcon fontSize="medium" />
                </Fab>
            </Grid>
        </Grid>

    )
}
